<template>
    <footer class="footer">
     <div class="container">
       <div class="row">
         <div class="col-md-4 order-2 order-md-1">
           <div class="text-center text-md-start">
             <div class="widget_block">
               <a href="https://play.google.com/store/apps/details?id=com.barn.promomatik.cekkazan&hl=en&gl=US" class="item_widget"
                 ><img
                   class="widget_img img-fluid"
                   src="/images/svg/google-play.svg"
                   alt=""
               /></a>
               <a href="https://apps.apple.com/tr/app/%C3%A7ek-kazan/id1175448426" class="item_widget"
                 ><img
                   class="widget_img img-fluid"
                   src="/images/svg/app-store.svg"
                   alt=""
               /></a>
               <a href="https://appgallery.huawei.com/app/C101761361" class="item_widget"
                 ><img
                   class="widget_img img-fluid"
                   src="/images/svg/appgallery.svg"
                   alt=""
               /></a>
             </div>
             <div class="text_sm color-white">
               İletişim :
               <a href="mailto:destek@barn.com.tr" class="color-white"
                 >destek@barn.com.tr</a
               >
             </div>
           </div>
         </div>
         <div class="col-md-4 order-1 order-md-3">
           <div class="text-center text-md-end">
             <h5 class="h5 color-white fw-600">Politikalarımız</h5>
             <ul class="footer_links">
               <li>
                 <a href="firma-gizlilik-politikasi" class="text_sm color-white">Gizlilik Politikası</a>
               </li>
               <li>
                 <a href="kullanim-kosullari" class="text_sm color-white">Kullanım Koşulları</a>
               </li>
               <li>
                 <a href="acik-riza-metni" class="text_sm color-white">Açık Rıza Metni</a>
               </li>
               <li>
                 <a href="uye-aydinlatma-metni" class="text_sm color-white">Üye Aydınlatma Metni</a>
               </li>
             </ul>
           </div>
         </div>
         <div class="col-md-4 order-3 order-md-2">
           <div class="text-center">
             <div class="logo_footer mt-3 mb-3">
                 <a href="https://justsnap.de/"><img class="img-fluid" src="/images/png/justsnap-logo.png" alt=""></a>
             </div>
             <div class="text_sm color-white mb-3">
               Powered by :
               <a href="https://justsnap.co/" class="color-white">Justsnap</a> Teknoloji A.Ş.
             </div>
             <div class="wrapper_social_btn wrapper_social_btn_footer">
                 <a href="https://www.facebook.com/cekkazan/" class="social_btn"><i class="lab la-facebook-f"></i></a>
                 <a href="https://www.instagram.com/cekkazan/" class="social_btn"><i class="lab la-instagram"></i></a>
                 <a href="https://www.youtube.com/cekkazan" class="social_btn"><i class="lab la-youtube"></i></a>
             </div>
           </div>
         </div>
       </div>
     </div>
   </footer>
</template>
<script>
export default {
  name: 'GlobalFoot'
}
</script>